import React from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { safeHTML } from '../../../utils/safeHTML';

const Match3Note = React.forwardRef(function Match3Note({ activeItem }, ref) {
  return (
    <>
      <TransitionGroup component={null}>
        {activeItem !== null ? (
          <CSSTransition
            key={`el-${activeItem}`}
            timeout={{ enter: 500, exit: 300 }}
            classNames={'match3__note'}
            mountOnEnter
            unmountOnExit
          >
            <div className={'match3__note'}>{safeHTML(activeItem)}</div>
          </CSSTransition>
        ) : (
          <div style={{ display: 'none' }} />
        )}
      </TransitionGroup>
    </>
  );
});
export default Match3Note;
Match3Note.propTypes = {};
